"use strict";

export default function routes($stateProvider) {
  "ngInject";

  $stateProvider.state("adDefaultsVideo", {
    url: "/adDefaultsVideo",
    template: "<ad-defaults-video></ad-defaults-video>",
  });
}



// WEBPACK FOOTER //
// ./client/app/adDefaultsVideo/adDefaults.routes.js